import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Box, Divider, TextField, Typography } from "@mui/material";
import { CartCard } from "./PreCheckout";
import { pink } from "@mui/material/colors";
import { useState } from "react";
import { Pen, Plus } from "@phosphor-icons/react";
import { CCard } from "../../components/common/CCard";
import EditPencil from "./../../assets/icons/akar-icons_edit.png";
import { useEffect } from "react";

const ContactItem = ({ value, isFocused, setIsFocused, label }) => {
  return (
    <Box
      sx={{
        position: "relative",
        // backgroundColor: "transparent",
        borderRadius: "8px",
        padding: "8px 16px",
        border: isFocused
          ? "1px solid var(--primary-color)"
          : "1px solid transparent",
        width: "100%",
        justifyContent: "center",
        display: "inline-flex",
        alignItems: "center",
        transition: "border 0.2s ease-in-out",
      }}
    >
      <TextField
        fullWidth
        placeholder={`Enter ${label}`}
        variant="standard"
        InputProps={{
          disableUnderline: true,
          style: { fontSize: "14px" },
        }}
        value={value}
        onChange={(e) => setMessage(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        sx={{
          backgroundColor: "transparent",
        }}
      />
      {!value ? (
        <Plus size={20} color="red" weight="bold" />
      ) : (
        <img src={EditPencil} alt="Edit" width={20} height={20} />
      )}
    </Box>
  );
};
export default function ContactInfo() {
  const [isFocused, setIsFocused] = useState(false);
  const [deliveryType, setDeliveryType] = useState("door_step_delivery");
  const [contactInfo, setContactInfo] = useState({
    name: "Armaan",
    mobile: "7667762218",
  });
  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "24px",
          color: "var(--neutral-black)",
          textAlign: "left",
          lineHeight: "133%",
          mb: 2,
        }}
      >
        Contact Info
      </Typography>
      <CCard sx={{ p: 0 }}>
        <ContactItem
          value={contactInfo?.name}
          isFocused={isFocused}
          setIsFocused={setIsFocused}
          label={"Name"}
        />

        <Divider variant="middle" sx={{ mX: 2, my: 0 }} />
        <ContactItem
          value={contactInfo?.mobile}
          isFocused={isFocused}
          setIsFocused={setIsFocused}
          label={"Mobile"}
        />
      </CCard>
    </Box>
  );
}
const deliveryTypeRadioItem = {
  borderRadius: "8px",
  border: "1px solid var(--neutral-200)",
  padding: "16px",
  height: "56px",
  m: 0,
  fontSize: "16px",
  fontWeight: 600,
  color: "var(--neutral-black)",
  "& .MuiTypography-root": {
    fontSize: "16px",
    fontWeight: 600,
    color: "var(--neutral-black)",
    lineHeight: "150%",
  },
};
